import apiAxios from './systemCommon/apiAxios';
export default {
    // 登录接口
    login(params, response) {
        apiAxios.postRequestBody('/auth/authCtrl/login', params, response);
    },
    /* 登出接口 */
    logout(params, response) {
        apiAxios.get('/auth/authCtrl/logout', params, response);
    },
    // 修改用户密码接口
    modifyPassword(params, response) {
        apiAxios.postRequestBody('/auth/authCtrl/changePassword', params, response);
    },
    /* 获取系统信息 */
    getSystemInfo(params, response) {
        apiAxios.get('/menuManager/getSystemInfo', params, response);
    },
    // 通过登入系统标识初始化菜单
    listInitMenuInfo(params, response) {
        apiAxios.postRequestBody('/menuManager/listInitMenuInfoByPlatformFlg', params, response);
    },
    // 初始化权限数据
    initPermissionInfo(params, response) {
        apiAxios.get('/auth/authCtrl/getAuthList', params, response);
    },
    // 查询组织人员树
    queryUserOrgTree(params, host, response) {
        apiAxios.postRequestBody('/role/queryUserOrgTree', params, response, host);
    },
    // 获取资源总线信息
    getResourceBusInfo(params, response) {
        apiAxios.get('/databusserver/mqConfigInfo/getAllConfigInfo', params, response);
    },
    // 获取资源总线指定mq信息
    getMQConfigInfoByMqId(params, response) {
        apiAxios.get('/databusserver/mqConfigInfo/getMQConfigInfoByMqId', params, response);
    },
    // 获取共通组件信息
    queryExtendInfo(params, response) {
        apiAxios.postRequestBody('/extendManage/queryExtendInfo', params, response);
    },
    //
    getDictValuesByType(params, response) {
        apiAxios.postRequestBody('/setting/dictController/getDictValuesByType', params, response);
    },
    //查询登录程序信息
    listLoginProcess(params, response) {
        apiAxios.get('/setting/dictController/getDictValuesByType', params, response);
    },
    //查询模块信息
    listModuleInfo(params, response) {
        apiAxios.postRequestBody('/systemManager/listModuleInfo', params, response);
    },
    //查询系统信息
    getSystemSettingInfo(params, response) {
        apiAxios.postRequestBody('/setting/systemSettingController/getSystemSettingInfo', params, response);
    },
    /* 获取需要验证的登录验证程序 */
    getLoginProcessMethod(params, response) {
        apiAxios.get('/auth/loginProcess/listLoginProcess', params, response);
    },
    /* 获取平台信息 */
    querySystemInfoByPlatformFlg(params, response) {
        apiAxios.postRequestBody('/systemManager/querySystemInfoByPlatformFlg', params, response);
    },
    /*保存平台信息 */
    savePlatFormConfig(params, response) {
        apiAxios.postRequestBody('/systemManager/savePlatFormConfig', params, response);
    },
    // 获取组织下所有人员信息
    getAllStaffInfo(params, response) {
        apiAxios.postRequestBody('/staffManager/getAllStaffInfo', params, response);
    },
    //删除上传文件
    deleteFile(params, response) {
        apiAxios.postRequestBody('/filemanage/deleteFile', params, response);
    },
    loginByIdCode(params, response) {
        apiAxios.postRequestBody('/auth/authCtrl/loginByIdCode', params, response);
    }
};
